import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { pruned, timelineSearchSchema, type TimelineSearch } from '@/components/Ams/search'
import { TimelinePage } from '@/components/Ams/TimelinePage'
import { inPageSearch } from '@/lib/searchNavigation'

/** Wiring only. */
export const Route = createFileRoute('/_app/marketing/ams/history/ad-group/$adGroupId')({
  validateSearch: timelineSearchSchema,
  component: AdGroupIdRoute,
})

function AdGroupIdRoute() {
  const { adGroupId } = Route.useParams()
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <TimelinePage
      level="ad-group"
      entityId={adGroupId}
      store={search.store}
      display={search}
      onDisplayChange={(next) => void navigate(inPageSearch<TimelineSearch>(pruned, next))}
    />
  )
}
